import { render, staticRenderFns } from "./wageMain.vue?vue&type=template&id=a0e68a1e"
import script from "./wageMain.vue?vue&type=script&lang=js"
export * from "./wageMain.vue?vue&type=script&lang=js"
import style0 from "./wageMain.vue?vue&type=style&index=0&id=a0e68a1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports